
      var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60.5,
  cy: 60,
  r: 39.8,
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.094 37.129a2.475 2.475 0 1 1 4.284 2.481L62.821 64.741a2.475 2.475 0 0 1-4.284-2.481l14.557-25.131z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.376 57.36a2.478 2.478 0 0 1 2.468-4.297l14.772 8.489a2.477 2.477 0 1 1-2.468 4.296l-14.772-8.489z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.23 27.971a1.98 1.98 0 0 1 3.96.02l-.02 4.038a1.98 1.98 0 0 1-3.96-.02l.02-4.038zm0 60a1.98 1.98 0 0 1 3.96.02l-.02 4.038a1.98 1.98 0 0 1-3.96-.02l.02-4.038zM92.529 57.73a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02zm-60 0a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <circle cx=\"60.5\" cy=\"60\" r=\"39.8\" stroke=\"#000\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M73.094 37.129a2.475 2.475 0 1 1 4.284 2.481L62.821 64.741a2.475 2.475 0 0 1-4.284-2.481l14.557-25.131z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M44.376 57.36a2.478 2.478 0 0 1 2.468-4.297l14.772 8.489a2.477 2.477 0 1 1-2.468 4.296l-14.772-8.489z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M58.23 27.971a1.98 1.98 0 0 1 3.96.02l-.02 4.038a1.98 1.98 0 0 1-3.96-.02l.02-4.038zM58.23 87.971a1.98 1.98 0 0 1 3.96.02l-.02 4.038a1.98 1.98 0 0 1-3.96-.02l.02-4.038zM92.529 57.73a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02zM32.529 57.73a1.98 1.98 0 0 1-.02 3.96l-4.038-.02a1.98 1.98 0 0 1 .02-3.96l4.038.02z\" fill=\"#000\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/clock.005094ee1dc7a8a1a89845aaa13c3d55.svg"),
        {
          React: SvgClock,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      